import { render } from "./ImportRequests.vue?vue&type=template&id=9c985504"
import script from "./ImportRequests.vue?vue&type=script&lang=js"
export * from "./ImportRequests.vue?vue&type=script&lang=js"

import "./ImportRequests.vue?vue&type=style&index=0&id=9c985504&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__